<template>
    <div style="padding: 10px;background-color: #fff;">
        <div class="tban" v-if="ind == 2">
            <el-button type="danger" size="medium" @click="submitForm(2)">通过</el-button>
            <el-button type="danger" plain size="medium" @click="submitForm(1)">驳回</el-button>
        </div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
                label-position="top">
                <div class="pfds">店铺信息</div>
                <el-row>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="门店全称" prop="title">
                            <el-input v-model="ruleForm.title" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="门店电话" prop="tel">
                            <el-input v-model="ruleForm.tel" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="门店位置" prop="detailAddress">
                            <el-input v-model="ruleForm.detailAddress" disabled
                                suffix-icon="el-icon-location-outline"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="门店街道" prop="street">
                            <el-select v-model="ruleForm.street" placeholder="请选择门店街道" style="width: 100%;" disabled >
                                <el-option v-for="item in options" :key="item.fullname" :label="item.fullname" 
                                    :value="item.fullname">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!-- <el-col :span="6" class="bgbian">
                        <el-form-item label="详细地址" prop="name">
                            <el-input v-model="ruleForm.detailAddress"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="营业时间" prop="businessTimeList">
                            <el-date-picker v-model="ruleForm.businessTimeList" type="daterange" range-separator="至" disabled
                                style="width: 100%;" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="统一社会信用代码" prop="creditCode">
                            <el-input v-model="ruleForm.creditCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="法人姓名" prop="legalName">
                            <el-input v-model="ruleForm.legalName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="法人手机号" prop="legalPhone">
                            <el-input v-model="ruleForm.legalPhone" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="法人身份证" prop="legalCode">
                            <el-input v-model="ruleForm.legalCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="法人邮箱" prop="name">
                            <el-input v-model="ruleForm.legalMail" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="pfds">证照信息</div>
                <div style="display: flex;">
                    <div style="text-align: center;">
                        <!-- <File-upload ref="refUpload"></File-upload> -->
                        <img :src="ruleForm.picUrls" style="width: 130px;height: 130px;">
                        <div style="margin-top: 20px;"><span style="color: red;margin-right: 3px;">*</span>门店照片</div>
                    </div>
                    <div style="text-align: center;margin-left: 200px;">
                        <!-- <File-upload ref="uploadRef"></File-upload> -->
                        <img :src="ruleForm.businessLicense" style="width: 130px;height: 130px;">
                        <div style="margin-top: 20px;">
                            <div><span style="color: red;margin-right: 3px;">*</span>门店营业执照</div>
                            <div>(个体户/公司)</div>
                        </div>
                    </div>
                </div>

                <div class="pfds">账号信息</div>
                <el-row>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="登陆账号" prop="account">
                            <el-input v-model="ruleForm.account" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="登陆密码" prop="password">
                            <el-input v-model="ruleForm.password" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="bgbian">
                        <el-form-item label="负责人手机号" prop="principalPhone">
                            <el-input v-model="ruleForm.principalPhone" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- <el-dialog title="腾讯地图" :visible.sync="qqMapDlg" width="50%" center>
            <qq-map-component @qqMapAddress="qqMapAddress"></qq-map-component>
        </el-dialog> -->
    </div>
</template>

<script>
// import FileUpload from './elUpload';
// import qqMapComponent from '../components/map/qqMapComponent.vue';
// import { addStoreFrontAudit } from '../api/index'
export default {
    data() {
        return {
            ruleForm: {},
            options: [],
            address: {},
            qqMapDlg: false,
            rules: {
                title: [
                    { required: true, message: '请输入门店全称', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入门店电话', trigger: 'blur' },
                    { min: 11, message: '请输入正确的门店电话', trigger: 'blur' }
                ],
                detailAddress: [
                    { required: true, message: '请选择门店位置', trigger: 'change' }
                ],
                street: [
                    { required: true, message: '请选择门店街道', trigger: 'change' }
                ],
                businessTimeList: [
                    { type: 'array', required: true, message: '请选择营业时间', trigger: 'change' }
                ],
                creditCode: [
                    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
                ],
                legalName: [
                    { required: true, message: '请输入法人姓名', trigger: 'blur' }
                ],
                legalPhone: [
                    { required: true, message: '请输入法人手机号', trigger: 'blur' },
                    { min: 11, message: '请输入正确的法人手机号', trigger: 'blur' }
                ],
                legalCode: [
                    { required: true, message: '请输入法人身份证', trigger: 'blur' },
                    { min: 18, message: '请输入正确的法人身份证', trigger: 'blur' }
                ],
                account: [
                    { required: true, message: '请输入登陆账号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入登陆密码', trigger: 'blur' }
                ],
                principalPhone: [
                    { required: true, message: '请输入负责人手机号', trigger: 'blur' },
                    { min: 11, message: '请输入正确的手机号', trigger: 'blur' }
                ]
            }
        };
    },
    props: {
        ruleForm: {
            type: Object,
            default: {}
        },
        ind:{
            type:Number,
            default:1
        }
    },
    components: {
        // FileUpload,
        // qqMapComponent
    },
    created() { },
    methods: {
        clickWZ() {
            // console.log(this.qqMapDlg, 'this.qqMapDlg======')
            this.qqMapDlg = true
        },
        qqMapAddress(data, lat, lng) {
            console.log(data, lat, lng, 'this.qqMapDlg======')
            this.address = data
            this.options = data.townList
            let detailAddress = data.city + data.district + data.street_number
            this.$set(this.ruleForm, 'detailAddress', detailAddress)
            this.$set(this.ruleForm, 'latitude', lat)
            this.$set(this.ruleForm, 'longitude', lng)
            this.qqMapDlg = false

        },
        submitForm(v) {
            this.$emit('submitFormtd',v)
        },
        addStore() {
            addStoreFrontAudit({ ...this.ruleForm }).then((res) => {
                if (res.code == 20000) {
                    this.ruleForm = {}
                    this.$refs['uploadRef'].imageUrl = ''
                    this.$refs['refUpload'].imageUrl = ''
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};
</script>
<style scoped lang="less">
.tban {
    width: 100%;
    text-align: right;
}

.bgbian {
    padding-right: 30px;
}

.pfds {
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
}

/deep/ .el-input.is-disabled .el-input__inner {
    cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/views/superadmin/StoreFrontAudit/distribution.vue